import React from 'react';

import styles from "./styles.module.css";

function TeacherBlogs() {
    return (
        <div className={styles.mainSection}>
            Under Development
        </div>
    )
}

export default TeacherBlogs;
